import React, { Component, ReactNode } from "react";
import ReactServer from "react-dom/server";

import PopoverTemplate from "./PopoverTemplate";

interface Props {
  children?: ReactNode;
  options?: {
    dismissible?: boolean;
    trigger?: string;
    animation?: string;
    placement?: string;
    delay?: number;
    container?: string | Element;
  };
  title?: string;
  triggerElement: (ref: React.RefObject<HTMLAnchorElement>) => JSX.Element;
}

/**
 * The render prop triggerElement takes an argument that is the
 * triggerElementRef and is required for the popover to function
 * properly and know what to bind events to.
 */
export default class Popover extends Component<Props> {
  private triggerElementRef = React.createRef<HTMLAnchorElement>();

  public componentDidMount() {
    import(/* webpackChunkName: "popover" */ "./styles.scss");

    const { title = "", options = {}, children } = this.props;
    const { current } = this.triggerElementRef;

    const template = ReactServer.renderToString(
      <PopoverTemplate
        title={title}
        {...(options.dismissible && { showClose: true })}
      >
        {children}
      </PopoverTemplate>,
    );

    if (!current) return;

    import("bootstrap.native").then(
      ({ default: { Popover: NativePopover } }) => {
        new NativePopover(current, {
          ...options,
          animation: "none",
          template,
        });
      },
    );
  }

  public render() {
    const { triggerElement } = this.props;

    return <>{triggerElement(this.triggerElementRef)}</>;
  }
}
